import { isObject } from '@utils/utils'

import VerticalNavMenuHeader from "@layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-header";
import VerticalNavMenuLink from "@layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue";
import VerticalNavMenuGroup from "@layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-group/VerticalNavMenuGroup.vue";
import router from '@/router';

/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveVerticalNavMenuItemComponent = item => {
  if (item.header) return VerticalNavMenuHeader
  if (item.children) return VerticalNavMenuGroup
  return VerticalNavMenuLink
}
/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveHorizontalNavMenuItemComponent = item => {
  if (item.children) return 'horizontal-nav-menu-group'
  return 'horizontal-nav-menu-link'
}

/**
 * Return route name for navigation link
 * If link is string then it will assume it is route-name
 * IF link is object it will resolve the object and will return the link
 * @param {Object, String} link navigation link object/string
 */
export const resolveNavDataRouteName = link => {
  if (isObject(link.route)) {
    const { route } = router.resolve(link.route)
    return route.name
  }
  return link.route
}

/**
 * Check if nav-link is active
 * @param {Object} link nav-link object
 */
export const isNavLinkActive = link => {
  // Matched routes array of current route
  const route = router.currentRoute;
  const matchedRoutes = route.value.matched

  // Check if provided route matches route's matched route
  const resolveRoutedName = resolveNavDataRouteName(link)

  if (!resolveRoutedName) return false  
  let nav_active_link = '';
  if(route.value.meta && route.value.meta.navActiveLink){
    nav_active_link = route.value.meta.navActiveLink;

    if (typeof nav_active_link == "function") {
      let querys = route.value.query;
      let va = nav_active_link(querys);
      nav_active_link = va;
    }
  }

  return matchedRoutes.some(route => route.name === resolveRoutedName || nav_active_link === resolveRoutedName)
}

/**
 * Check if nav group is
 * @param {Array} children Group children
 */
export const isNavGroupActive = children => {
  // Matched routes array of current route
  const matchedRoutes = router.currentRoute.matched

  return children.some(child => {
    // If child have children => It's group => Go deeper(recursive)
    if (child.children) {
      return isNavGroupActive(child.children)
    }

    // else it's link => Check for matched Route
    return isNavLinkActive(child, matchedRoutes)
  })
}



/**
 * Return b-link props to use
 * @param {Object, String} item navigation routeName or route Object provided in navigation data
 */
// prettier-ignore
export const navLinkProps = item => computed(() => {
  
  const props = {}
  // If route is string => it assumes => Create route object from route name
  // If route is not string => It assumes it's route object => returns route object
  if (item.route) props.to = typeof item.route === 'string' ? { name: item.route } : item.route
  else {
    props.href = item.href
    props.target = '_blank'
    props.rel = 'nofollow'
  }

  if (!props.target) props.target = item.target || null


   if(item.exact){
     props.exact = item.exact
   }

   if(item.ExactPath){
     props.ExactPath = item.ExactPath
   }

   if(item.class){
    props.class = item.class 
   }
   if(item.fontAwesome){
    props.fontAwesome = item.fontAwesome
   }

  //  if(item.icon){
  //   props.icon = item.icon
  //  }

   if(typeof item.route.query == 'function'){
    item.route.query(item.queryId).then((data) => {
      nextTick(() => {
        item.route.query = data ;  
      })
    })
   }

  
  return props
})
